import React from "react";
import { Button, Modal } from "react-bootstrap";
import newLogo from "../../assets/new_logo.png";

const CompleteProfileModel = (props) => {
  const close = () => {
    props.setActive(false);
  };
  const navigate = () => {
    console.log();
    close();
    if (props.target === "POLICY_MASTER")
      window.location.href = "/completephprofile";
    if (props.target === "INVESTOR") window.location.href = "/investorKyc";
    if (props.target === "PARTNER")
      window.location.href = "/partner-registration";
  };
  
  return (
    <div>
      <Modal
        show={props.active}
        centered
        onHide={() => {
          props.setActive(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Tell Us About Yourself</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-5 d-flex justify-content-center">
              {" "}
              <img src={newLogo} alt="" height={130}></img>
            </div>
            <div className="col-7  align-self-center">
              <b>We at The Policy Exchange take good care of our customers.</b>
              <p className="font-weight-light ">
                <small>Please help us by answering few questions.</small>
              </p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <Button
            className="px-5 py-2 mx-1"
            variant="outline-primary"
            onClick={() => {
              close();
            }}
          >
            Maybe Later
          </Button>
          <Button
            className="mx-1 px-4 py-2"
            onClick={() => {
              navigate();
            }}
          >
            Yes, let's get started
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CompleteProfileModel;
